VjsAdmin.Stats = (function () {
    const $table = $('#stats-table');
    const init = function () {
        initStatsTable();
        new Main();
    };

    const Main = VjsUtility.Controller.extend({
        events: {
            'change #type-filter': 'quickTypeFilter',
            'change #date1-filter': 'quickTypeFilter',
            'change #date2-filter': 'quickTypeFilter',
        },
        quickTypeFilter() {
            $table.bootstrapTable('refresh', { url: '/api/stats/' });
        },
    });

    const initStatsTable = function () {
        $table.bootstrapTable({
            ...VjsTable.simpleTableDefaults(),
            table: '#stats-table',
            method: 'get',
            formatNoMatches() {
                return 'No stats AT ALL!!!';
            },
            idField: 'dns',
            showRefresh: true,
            showColumns: true,
            pagination: true,
            sidePagination: 'server',
            search: false,
            queryParams: (params) => {
                params.type = $('#type-filter').val();
                params.date1 = $('#date1-filter').val();
                params.date2 = $('#date2-filter').val();
                return params;
            },
            pageList: [500],
            pageSize: 500,
            toolbar: '#table-toolbar',
            icons: {
                refresh: 'fa-refresh',
            },
            sortName: 'created_at',
            sortOrder: 'desc',
            url: '/api/stats/',
            columns: [
                {
                    title: 'DNS',
                    field: 'dns',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    searchable: true,
                },
                {
                    title: 'Created At',
                    field: 'created_at',
                    align: 'center',
                    valign: 'middle',
                    visible: true,
                    searchable: false,
                    sortable: true,
                },
                {
                    title: 'Email',
                    field: 'email',
                    align: 'center',
                    valign: 'middle',
                    visible: true,
                    searchable: false,
                    sortable: true,
                },
            ],
            responseHandler(res) {
                return {
                    total: res.meta.total ? res.meta.total : 0,
                    rows: res.data,
                };
            },
        });
    };

    return {
        init,
    };
}());
